import { useCallback, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { TbMoon, TbSettings, TbSun } from "react-icons/tb";

import { NotificationsPopover } from "../NotificationsPopover";
import { HomeAccountSelector } from "../HomeAccountSelector";
import { getStoredSelectedAccountId } from "../../../Constants/accountTypes";
import { useColorMode } from "../../../Hooks/useColorMode";
import { BaasHeaderControls } from "../../../Pages/Private/BaasConsole/components/BaasHeaderControls";
import { isBaasPath } from "../../../Pages/Private/BaasConsole/constants";
import {
  HEADER_ACTION_BTN_CLASS,
  HEADER_ACTION_ICON_CLASS,
  HEADER_ACTION_ICON_SIZE,
} from "./headerActionStyles";

/** IB Carteira home (Dashboard). Not `/baas/inicio`. */
const IB_HOME_PATH = "/";

export const HeaderActionButtons = () => {
  const { isDark, toggle } = useColorMode();
  const location = useLocation();
  const isBaas = isBaasPath(location.pathname);
  const showIbAccountSelector = !isBaas;
  const lastAccountIdRef = useRef(getStoredSelectedAccountId());

  // Persist already happens in HomeAccountSelector (setStoredSelectedAccountId + event).
  // On real user switch: go to IB home and hard-reload so balances/context reset.
  const handleActiveAccountChange = useCallback((accountId: string | null) => {
    const nextId = accountId != null && accountId !== "" ? String(accountId) : null;
    if (!nextId || nextId === lastAccountIdRef.current) return;
    lastAccountIdRef.current = nextId;
    // Hard navigation clears stale page state (balances, product features, etc.).
    const onHome =
      window.location.pathname === IB_HOME_PATH || window.location.pathname === "";
    if (onHome) {
      window.location.reload();
    } else {
      window.location.assign(IB_HOME_PATH);
    }
  }, []);

  return (
    <nav className="flex min-w-0 shrink items-center gap-1.5 sm:gap-2" aria-label="Ações do cabeçalho">
      {isBaas ? <BaasHeaderControls /> : null}

      <div className="flex shrink-0 items-center gap-0.5 sm:gap-1">
        <button
          type="button"
          className={HEADER_ACTION_BTN_CLASS}
          aria-label={isDark ? "Ativar modo claro" : "Ativar modo escuro"}
          onClick={toggle}
        >
          {isDark ? (
            <TbSun
              size={HEADER_ACTION_ICON_SIZE}
              className={`${HEADER_ACTION_ICON_CLASS} text-brand-gold-mid`}
              aria-hidden
            />
          ) : (
            <TbMoon
              size={HEADER_ACTION_ICON_SIZE}
              className={HEADER_ACTION_ICON_CLASS}
              aria-hidden
            />
          )}
        </button>

        <NotificationsPopover />

        <Link
          to="/perfil"
          className={HEADER_ACTION_BTN_CLASS}
          aria-label="Configurações da conta"
        >
          <TbSettings
            size={HEADER_ACTION_ICON_SIZE}
            className={HEADER_ACTION_ICON_CLASS}
            aria-hidden
          />
        </Link>
      </div>

      {showIbAccountSelector ? (
        <div className="header-account-selector min-w-0">
          <HomeAccountSelector onActiveAccountChange={handleActiveAccountChange} />
        </div>
      ) : null}
    </nav>
  );
};
